<div id="{{target}}" class="map"></div>
<div id="popup" class="ol-popup">
  <span id="popup-closer" class="ol-popup-closer" (click)="closePopUp()"></span>
  <div id="popup-content">
    <div *ngIf="subBarrioSelected">
    {{subBarrioSelected.nombre}}<br/>
    <p-chart type="doughnut" [data]="{
      labels: ['Libre %', 'Ocupada %'],
      datasets: [
      {
        data: [ (100 - subBarrioSelected.ocupacionMedia).toFixed(2),subBarrioSelected.ocupacionMedia.toFixed(2)],
        backgroundColor: [green,red],
        hoverBackgroundColor: [green,red]
      }
      ]
    }"></p-chart>
    Plazas totales : {{subBarrioSelected.plazasTotales}}<br/>
    Plazas ocupadas : {{subBarrioSelected.plazasTotales - subBarrioSelected.plazasDisponible}}<br/>
    Plazas disponibles : {{subBarrioSelected.plazasDisponible}}
  </div>
  </div>
</div>
